"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../colors"));
const breakpoints_1 = __importDefault(require("../../theme/breakpoints"));
const typography_1 = __importDefault(require("../../theme/typography"));
const input = {
    MuiInput: {
        styleOverrides: {
            root: {
                padding: "10px",
                borderRadius: "16px",
                "&:hover": {
                    border: "solid thin",
                    borderColor: colors_1.default.border[100],
                },
                "&.Mui-focused": {
                    border: `solid thin ${colors_1.default.border[100]}`,
                },
                "&.Mui-disabled": {
                    border: `solid thin ${colors_1.default.inputDisabled[900]} `,
                },
                "&.Mui-error": {
                    border: `solid thin ${colors_1.default.error} `,
                },
            },
            input: {
                padding: 4,
                // Fix browser auto suggest styling
                "&:-webkit-autofill": {
                    transition: "background-color 600000s 0s, color 600000s 0s",
                },
                "&:-webkit-autofill:focus": {
                    transition: "background-color 600000s 0s, color 600000s 0s",
                },
            },
        },
    },
    MuiInputLabel: {
        styleOverrides: {
            root: {
                fontSize: typography_1.default.caption.fontSize,
                letterSpacing: "0.3px",
                [breakpoints_1.default.up("sm")]: {
                    fontSize: "0.65rem",
                },
                [breakpoints_1.default.up("xl")]: {
                    fontSize: "0.7rem",
                },
            },
            shrink: {
                fontSize: typography_1.default.caption.fontSize,
                letterSpacing: "0.3px",
                [breakpoints_1.default.up("sm")]: {
                    fontSize: "0.65rem",
                },
                [breakpoints_1.default.up("xl")]: {
                    fontSize: "0.7rem",
                },
                position: "relative",
                transform: "none",
                marginBottom: 3,
                "&.Mui-error": {
                    color: colors_1.default.text[600],
                },
            },
        },
    },
    MuiInputBase: {
        styleOverrides: {
            root: {
                minHeight: "50px",
                input: {
                    "&.Mui-disabled": {
                        WebkitTextFillColor: colors_1.default.inputDisabled[100],
                    },
                },
                "&.Mui-disabled": {
                    border: `solid thin ${colors_1.default.inputDisabled[900]} `,
                    "&:hover": {
                        border: `solid thin ${colors_1.default.inputDisabled[900]} `,
                    },
                },
                marginTop: "0 !important",
                fontSize: "0.9rem !important",
                border: "thin solid",
                borderColor: colors_1.default.border[700],
                background: colors_1.default.secondary[600],
                borderRadius: "1rem",
                "&:disabled": {
                    background: colors_1.default.inputDisabled[900],
                },
                "&:focus": {
                    outline: "rgba(255, 255, 255, 0)",
                },
            },
            sizeSmall: {
                minHeight: "40px !important",
                padding: "4px !important",
                borderRadius: "8px !important",
            },
        },
    },
    MuiOutlinedInput: {
        styleOverrides: {
            root: {
                fontSize: 14.5,
                color: colors_1.default.text[100],
                backgroundColor: colors_1.default.secondary[600],
                "&.Mui-focused": {
                    ".MuiOutlinedInput-notchedOutline": {
                        borderColor: colors_1.default.text[600],
                        borderWidth: "thin",
                        zIndex: 10,
                    },
                },
                "&:hover": {
                    ".MuiOutlinedInput-notchedOutline": {
                        borderColor: colors_1.default.text[600],
                    },
                },
            },
            input: {
                "&:disabled": {
                    color: colors_1.default.text[600],
                    textFillColor: colors_1.default.text[600],
                    "&:error": colors_1.default.error,
                },
            },
            notchedOutline: {
                border: "none",
            },
        },
    },
    MuiTextField: {
        defaultProps: {
            variant: "standard",
        },
    },
};
exports.default = input;
